import {ReviewerIdentity} from '../../reviewers/ReviewerIdentity'
import type {TeamReviewer} from '../../../../page-data/payloads/review-requests'
import styles from './DelegatedFromTeams.module.css'

// Renders the "Assigned from <team>" delegation note with rich, linked team identities.
// Mirrors OnBehalfOfTeams, but tailored to the reviewer-delegation ("assigned from") context.
export function DelegatedFromTeams({teams}: {teams: TeamReviewer[]}) {
  if (teams.length === 0) return null

  return (
    <span className={styles.delegationNote}>
      Assigned from{' '}
      {teams.map((team, i) => (
        <span key={team.id} className={styles.teamList}>
          <ReviewerIdentity reviewer={team} withAvatar={false} inline />
          {i < teams.length - 1 && <span className={styles.separator}>, </span>}
        </span>
      ))}
    </span>
  )
}
